import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

export default function useApiToken() {
  const { instance, accounts } = useMsal();
  const [token, setToken] = useState<string>();

  useEffect(() => {
    const getToken = async () => {
      try {
        const currentAccount =
          instance.getActiveAccount() ?? accounts[0];

        if (!currentAccount) return;

        const accessTokenRequest = {
          scopes: [
            "api://7da5a83f-58c1-4fdf-b5e4-bb00829c8ac1/Recruitment.Read",
          ],
          account: currentAccount,
        };

        const accessToken =
          await instance.acquireTokenSilent(accessTokenRequest);

        setToken(accessToken.accessToken);
      } catch (err) {
        console.error("useApiToken failed:", err);
      }
    };

    getToken();
  }, [instance, accounts]);

  return token;
}
